var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import toast from 'react-hot-toast';
import { colorsNew } from 'root/src/client/web/commonStyles';
import { useEnterGiveawayApi } from 'root/src/client/web/giveaway/hooks/useEnterGiveawayApi';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
export const useVerifySteamStageSuccess = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { hide } = useModal();
    const { enterGiveaway } = useEnterGiveawayApi();
    const onEnterGiveaway = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            yield enterGiveaway();
            toast.success('Successfully entered giveaway!');
        }
        catch (err) {
            console.error(err);
            toast.error('Failed to enter giveaway', {
                style: {
                    backgroundColor: colorsNew.red,
                    color: colorsNew.white,
                },
            });
        }
        setIsLoading(false);
        hide();
    });
    return {
        onEnterGiveaway,
        isLoading,
    };
};
